<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

import Table from '../common/SortedTable.vue'
import OrderDetail from './OrderDetailComponent.vue'

import apiOrders from '@/api/api-orders.js'

export default {
    name: 'OrdersComponent',

    components: {
        Table,
        OrderDetail
    },

    props: {
        userLanguage: {
            type: String,
            default: 'cz'
        },
        languageStrings: {
            type: Object,
            default: () => {}
        },
        userId: {
            type: Number,
            defaults: -1
        },
        role: {
            type: Number,
            default: 0
        },
        searchString: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            orders: [],
            selectedOrders: [],
            notEvaluatedOrders: true,
            notInvoicedOrders: false,
            partiallyInvoicedOrders: false,
            allOrders: false
        }
    },

    computed: {
        filteredOrders() {
            return this.searchString.length === 0 
                ? this.orders 
                : this.orders.slice().filter(o => o.header.number.includes(this.searchString) 
                    || o.header.customer.name.toLowerCase().includes(this.searchString.toLowerCase())
                    || (o.resposiblePerson != null && o.resposiblePerson.toLowerCase().includes(this.searchString.toLowerCase())))
        },
        headers() {
            let h = [
                {
                    id: 'number',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.order005 != null ? this.languageStrings.ui.order005 : 'Číslo objednávky',
                    sort: true
                },
                {
                    id: 'responsible-person',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.order024 != null ? this.languageStrings.ui.order024 : 'Odpovědná osoba',
                    sort: true
                },
                {
                    id: 'invoice-number',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.order025 != null ? this.languageStrings.ui.order025 : 'Číslo faktury',
                    sort: true,
                    width: 135
                },
                {
                    id: 'invoice-number-2',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.order025 != null ? this.languageStrings.ui.order025 : 'Číslo faktury') + ' 2',
                    sort: true,
                    width: 135
                },
                {
                    id: 'invoice-date',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.order026 != null ? this.languageStrings.ui.order026 : 'Datum\nfakturace',
                    sort: true,
                    sortType: 'date'
                },
                {
                    id: 'no-invoice',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.order027 != null ? this.languageStrings.ui.order027 : 'Nefakt.',
                    sort: true
                },
                {
                    id: 'locked-date',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.order028 != null ? this.languageStrings.ui.order028 : 'Datum\nodeslání obj.',
                    sort: true,
                    sortType: 'date'
                },
                {
                    id: 'customer',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.order029 != null ? this.languageStrings.ui.order029 : 'Zákazník',
                    sort: true
                },
                {
                    id: 'sample-count',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.order030 != null ? this.languageStrings.ui.order030 : 'Počet\nvz. obj.',
                    sort: true,
                    sortType: 'number'
                },
                {
                    id: 'sample-for-evaluation-count',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.order031 != null ? this.languageStrings.ui.order031 : 'Počet vz.\nk vyhod.',
                    sort: true,
                    sortType: 'number'
                },
                {
                    id: 'sample-evaluated-count',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.order032 != null ? this.languageStrings.ui.order032 : 'Počet vz.\nvyhod.',
                    sort: true,
                    sortType: 'number'
                },
                {
                    id: 'sum-als-price',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.order033 != null ? this.languageStrings.ui.order033 : 'Cena pro\nALS [Kč]',
                    sort: true,
                    sortType: 'number'
                },
                {
                    id: 'sample-customer-price',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.order034 != null ? this.languageStrings.ui.order034 : 'Cena pro zák.\nza SIF [Kč]',
                    sort: true,
                    sortType: 'number'
                },
                {
                    id: 'sum-customer-price',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.order035 != null ? this.languageStrings.ui.order035 : 'Cena pro zák.\ncelkem [Kč]',
                    sort: true,
                    sortType: 'number'
                }
            ]
            return h
        },
        rows() {
            let r = []
            for (let i = 0; i < this.filteredOrders.length; i++) {
                if (this.filteredOrders[i].header == null) {
                    continue
                }

                r.push({
                    id: this.filteredOrders[i].header.id,
                    selected: (this.selectedOrders.includes(this.filteredOrders[i].header.id)),
                    cells: [
                        {
                            id: 'number',
                            contenttype: 'text',
                            content: this.filteredOrders[i].header.number
                        },
                        {
                            id: 'responsible-person',
                            contenttype: 'text',
                            content: (this.filteredOrders[i].resposiblePerson != null ? this.filteredOrders[i].resposiblePerson : '')
                        },
                        {
                            id: 'invoice-number',
                            contenttype: 'text',
                            content: (this.filteredOrders[i].header.invoiceNumber != null ? this.filteredOrders[i].header.invoiceNumber : ''),
                            width: 135
                        },
                        {
                            id: 'invoice-number-2',
                            contenttype: 'text',
                            content: (this.filteredOrders[i].header.invoiceNumber2 != null ? this.filteredOrders[i].header.invoiceNumber2 : ''),
                            width: 135
                        },
                        {
                            id: 'invoice-date',
                            contenttype: 'text',
                            content: (this.filteredOrders[i].header.invoiceDate != null ? this.formatDate(this.filteredOrders[i].header.invoiceDate) : '')
                        },
                        {
                            id: 'no-invoice',
                            contenttype: 'text',
                            content: (this.filteredOrders[i].header.noInvoice != null ? this.filteredOrders[i].header.noInvoice ? (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.form003 != null ? this.languageStrings.ui.form003 : 'Ano') : (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.form004 != null ? this.languageStrings.ui.form004 : 'Ne') : (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.form004 != null ? this.languageStrings.ui.form004 : 'Ne'))
                        },
                        {
                            id: 'locked-date',
                            contenttype: 'text',
                            content: (this.filteredOrders[i].header.lockedDate != null ? this.formatDate(this.filteredOrders[i].header.lockedDate) : '')
                        },
                        {
                            id: 'customer',
                            contenttype: 'text',
                            content: (this.filteredOrders[i].header.customer != null && this.filteredOrders[i].header.customer.name != null ? this.filteredOrders[i].header.customer.name : '')
                        },
                        {
                            id: 'sample-count',
                            contenttype: 'text',
                            content: (this.filteredOrders[i].sampleCount != null ? this.filteredOrders[i].sampleCount : 0)
                        },
                        {
                            id: 'sample-for-evaluation-count',
                            contenttype: 'text',
                            content: (this.filteredOrders[i].sampleForEvaluationCount != null ? this.filteredOrders[i].sampleForEvaluationCount : 0)
                        },
                        {
                            id: 'sample-evaluated-count',
                            contenttype: 'text',
                            content: (this.filteredOrders[i].sampleEvaluatedCount != null ? this.filteredOrders[i].sampleEvaluatedCount : 0)
                        },
                        {
                            id: 'sum-als-price',
                            contenttype: 'text',
                            content: (this.filteredOrders[i].sumALSPrice != null ? this.filteredOrders[i].sumALSPrice : 0)
                        },
                        {
                            id: 'sample-customer-price',
                            contenttype: 'text',
                            content: (this.filteredOrders[i].sampleCustomerPrice != null ? this.filteredOrders[i].sampleCustomerPrice : 0)
                        },
                        {
                            id: 'sum-customer-price',
                            contenttype: 'text',
                            content: (this.filteredOrders[i].sumCustomerPrice != null ? this.filteredOrders[i].sumCustomerPrice : 0)
                        }
                    ]
                })
            }
            return r
        }
    },

    mounted() {
        this.refreshOrders()      
    },

    methods: {
        formatDate(date) {
            return date !== null ? dayjs(date + 'Z').utcOffset(0).format('D.M.YYYY') : ''
        },
        async refreshOrders() {
            this.selectedOrders = []
            this.orders = []
            let result = await apiOrders.getOrders(this.notEvaluatedOrders, this.notInvoicedOrders, this.partiallyInvoicedOrders)
            if (result.code === 0) {
                this.orders = result.data
            }
        },
        setSelectedOrders(value) {
            this.selectedOrders = value
        },
        onRadioChange(event) {
            this.notEvaluatedOrders = false
            this.notInvoicedOrders = false
            this.partiallyInvoicedOrders = false
            this.allOrders = false

            switch (event.target.value) {
                case 'notEvaluatedOrders':
                    this.notEvaluatedOrders = true
                    break
                case 'notInvoicedOrders':
                    this.notInvoicedOrders = true
                    break
                case 'partiallyInvoicedOrders':
                    this.partiallyInvoicedOrders = true
                    break
                case 'allOrders':
                    this.allOrders = true
                    break
            }

            this.refreshOrders()
        },
        orderUpdated(id) {
            this.refreshOrders()
            this.selectedOrders = id !== -1 ? [ id ] : []
        },
        newOrder() {
            this.selectedOrders = [ -1 ]
        }
    }
}
</script>

<template>
    <div class="content">
        <div class="orders">
            <div class="pane-button-strip">
                <div class="left-icons button-to-hide">
                    <span>
                        <input type="radio" value="notEvaluatedOrders" :checked="notEvaluatedOrders" @change="onRadioChange" name="group1">
                        {{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.order020 != null ? languageStrings.ui.order020 : 'Nevyhodnocené' }}
                    </span>
                    <span>
                        <input type="radio" value="notInvoicedOrders" :checked="notInvoicedOrders" @change="onRadioChange" name="group1">
                        {{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.order021 != null ? languageStrings.ui.order021 : 'Nevyfakturované' }}
                    </span>
                    <span>
                        <input type="radio" value="partiallyInvoicedOrders" :checked="partiallyInvoicedOrders" @change="onRadioChange" name="group1">
                        {{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.order022 != null ? languageStrings.ui.order022 : 'Částečně fakturované' }}
                    </span>
                    <span>
                        <input type="radio" value="allOrders" :checked="allOrders" @change="onRadioChange" name="group1">
                        {{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.order023 != null ? languageStrings.ui.order023 : 'Vše' }}
                    </span>
                </div>

                <button class="button-strip button-to-hide" @click="newOrder()">
                    <img src="@/assets/images/plus.svg" 
                        :title="this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.order019 != null ? this.languageStrings.ui.order019 : 'Nová objednávka'" />
                </button>

                <button class="button-strip button-to-hide" @click="refreshOrders()">
                    <img src="@/assets/images/refresh-cw.svg" 
                        :title="this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.tooltip001 != null ? this.languageStrings.ui.tooltip001 : 'Obnovit'" />
                </button>
            </div>

            <div class="orders-content cols">
                <div class="orders-table">
                    <Table v-if="filteredOrders.length > 0" :headers="headers" :rows="rows" @selected-items="setSelectedOrders" />
                </div>

                <div v-if="selectedOrders.length > 0" class="orders-detail">
                    <OrderDetail :order-id="selectedOrders.length > 0 ? selectedOrders[0] : -1" :user-language="userLanguage" :language-strings="languageStrings" :user-id="userId" @order-updated="orderUpdated" />
                </div>
            </div>
        </div>
    </div>
</template>